export const NATIVE_OAUTH_FINISHED_EVENT = 'public-pulse:native-oauth-finished';
export const DESKTOP_OAUTH_CALLBACK_RECEIVED_EVENT = 'public-pulse:desktop-oauth-callback-received';
